module.exports = __webpack_public_path__ + "img/userportrait.8da3ce59.jpg";